export var addBrackets = function(string) {
    if (string.startsWith("(") && string.endsWith(")")) {
        return string;
    }
    return "(".concat(string, ")");
};
